import type { OAuthProvider } from "./oauth-providers";

/** Which third-party sign-in buttons to render, in display order.
 *
 *  App Review guideline 4.8: an app offering a third-party login must ALSO
 *  offer a service that limits collection to name + email, keeps the email
 *  private, and doesn't collect app interactions for ads. Email/password
 *  does NOT qualify — it fails the private-email clause, which is exactly
 *  why submission 1.0 (2) was rejected on 4.8 despite having one. Sign in
 *  with Apple is the service Apple names, so it must be present wherever
 *  Google is.
 *
 *  Order is NOT constrained. Apple's HIG asks only that the Sign in with
 *  Apple button be "no smaller than other sign-in buttons" and that people
 *  not have to scroll to see it — both of which hold by construction, since
 *  every provider renders through OAuthButton at the same size, above the
 *  email/password form.
 *
 *  Removing "apple" from either list while "google" remains re-earns that
 *  rejection. The shell may return [] instead — 4.8 doesn't apply when an
 *  app "exclusively uses your company's own account setup and sign-in
 *  systems" — but a Google-only shell is the one combination that fails.
 *
 *  Consulted in TWO places, deliberately. The UI reads it to decide what to
 *  render, which is where 4.8 is satisfied since the guideline governs what
 *  an app OFFERS. The OAuth Server Actions read it too and refuse a
 *  provider the caller isn't offered: a Server Action is a POST endpoint
 *  any client with a session can reach, so "nothing links to it" is not
 *  "nothing can call it". */
const WEB_PROVIDERS: readonly OAuthProvider[] = ["google", "apple"];

const SHELL_PROVIDERS: readonly OAuthProvider[] = ["google", "apple"];

export function availableOAuthProviders(shell: boolean): readonly OAuthProvider[] {
  return shell ? SHELL_PROVIDERS : WEB_PROVIDERS;
}
